import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required} from "yup";
import FormFields from './FormFields'

class ContactForm extends React.Component {

    render() {
        const {
            values,
            contactType
        } = this.props;

        values.contact_type = contactType;

        if (typeof values.is_company == 'string' && contactType == 'craft') {
            values.is_company = true
        }

        return <FormFields {...this.props}/>
    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            contact_type: '',
            tenant_since: '',
            search_number: '',
            first_name: '',
            last_name: '',
            is_company: '',
            company_name: '',
            department: '',
            street: '',
            housenumber: '',
            zip: '',
            city: '',
            telephone: '',
            email: '',
            website: '',
            salutation: '',
        });
    },

    validationSchema: () => {
        let rules = object().shape({
            is_company: boolean().required(),
            company_name: string().when("is_company", (is_company, schema) => {
                return is_company === true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.company_name')})
                ) : schema;
            }),
            first_name: string().when("is_company", (is_company, schema) => {
                return is_company !== true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
                ) : schema;
            }),
            last_name: string().when("is_company", (is_company, schema) => {
                return is_company !== true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')})
                ) : schema;
            }),
        })

        // todo: company nur validieren wenn checkbox angehakt
        // company_name: string().required(
        //     i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
        // )

        return rules
    },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('contacts.save_success'),
                text: i18n.get('contacts.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('contacts.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(ContactForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Contacts/ContactForm.js